<div class="btn-group btn-group-toggle" data-toggle="buttons">
  <label class="btn btn-secondary" [class.active]="type===trendType" *ngFor="let type of trendsTypes" (click)="setTrendType(type)" >
    <input type="radio" name="options" id="option1" autocomplete="off" [checked]="(type===trendType ? true : null )"> {{'shared.filters.trends.'+type | translate }}
  </label>
</div>
